import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'ForkliftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-forklift",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M5 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M14 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M7 17l5 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M3 17v-6h13v6"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M5 11v-4h4"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M9 11v-6h4l3 6"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M22 15h-3v-10"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M16 13l3 0"
    }, null), _createTextVNode(" ")]);
  }
};